import { useContext } from 'react';

import { DragAndDropOptionsContext } from '../../ui/drag-and-drop-options-provider';
export const useDragAndDropOptions = () => {
	const context = useContext(DragAndDropOptionsContext);

	if (!context) {
		return { enabled: false };
	}

	return {
		enabled: context.enabled,
	};
};
